import styled from 'styled-components';

const HEADER_TYPEFACE = 'Halant, neuton, radley, serif';
const BODY_TYPEFACE = 'DM Sans, sans-serif';
const headerFont = {
    fontFamily: HEADER_TYPEFACE,
    fontWeight: 'bold',
};
const bodyFont = {
    fontFamily: BODY_TYPEFACE,
};
const fontSizes = {
    title: '3rem',
    base: '1rem',
    h1: '2rem',
    h2: '1.7rem',
    h3: '1.25rem',
    h4: '1rem',
    p1: '.9rem',
    p2: '0.7rem',
    p3: '0.625rem',
};
const Title = styled.div({
    fontSize: fontSizes.title,
    lineHeight: '4rem',
    '@media (max-width: 600px)': {
        fontSize: '2.5rem',
        lineHeight: '3.5rem',
    },
    ...headerFont,
});
const H1 = styled.div({
    fontSize: fontSizes.h1,
    ...headerFont,
});
const H2 = styled.div({
    fontSize: fontSizes.h2,
    ...headerFont,
});
const H3 = styled.div({
    fontSize: fontSizes.h3,
    ...headerFont,
});
const H4 = styled.div({
    fontSize: fontSizes.h4,
    fontWeight: '400',
    ...bodyFont,
});
const P1 = styled.div({
    fontSize: fontSizes.p1,
    lineHeight: '1.3rem',
    fontWeight: '400',
    ...bodyFont,
});
const P2 = styled.div({
    fontSize: fontSizes.p2,
    lineHeight: '1.3rem',
    fontWeight: '400',
    ...bodyFont,
});
const P3 = styled.div({
    fontWeight: 200,
    fontSize: fontSizes.p3,
    lineHeight: '1rem',
    ...bodyFont,
});

export { BODY_TYPEFACE, H1, H2, H3, H4, HEADER_TYPEFACE, P1, P2, P3, Title, fontSizes };
